/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OAuthResponseDto } from '../../models/o-auth-response-dto';

export interface KakaoAuthControllerLogin$Params {
  code: string;
  redirectUri: string;
  role: any;
}

export function kakaoAuthControllerLogin(http: HttpClient, rootUrl: string, params: KakaoAuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, kakaoAuthControllerLogin.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('redirectUri', params.redirectUri, {});
    rb.query('role', params.role, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OAuthResponseDto>;
    })
  );
}

kakaoAuthControllerLogin.PATH = '/api/oauth/kakao/signin';
